export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  servicesLink: "nav-services",
  whyUsLink: "nav-why-us",
  areasLink: "nav-areas",
  brandsLink: "nav-brands",
  contactLink: "nav-contact",
  phoneLink: "nav-phone",
  bookButton: "nav-book-button",
};

export const HERO = {
  badge: "hero-badge",
  title: "hero-title",
  bookButton: "hero-book-button",
  callButton: "hero-call-button",
};

export const SERVICES = {
  section: "services-section",
  card: (slug) => `service-card-${slug}`,
  bookLink: (slug) => `service-book-${slug}`,
  freeDiagnosisButton: "services-free-diagnosis-btn",
};

export const WHY = {
  section: "why-us-section",
  bookButton: "why-book-button",
  whatsappButton: "why-whatsapp-button",
};

export const BRANDS = {
  section: "brands-section",
};

export const AREAS = {
  section: "areas-section",
  card: (slug) => `service-area-${slug}`,
};

export const CTA = {
  section: "cta-section",
  callButton: "cta-call-button",
  bookButton: "cta-book-button",
};

export const LEAD = {
  section: "lead-form-section",
  form: "lead-form",
  name: "lead-name-input",
  phone: "lead-phone-input",
  brand: "lead-brand-select",
  issue: "lead-issue-select",
  location: "lead-location-input",
  message: "lead-message-input",
  submit: "lead-submit-button",
  success: "lead-success-message",
  error: "lead-error-message",
};

export const FOOTER = {
  section: "footer",
};

export const MOBILE_BAR = {
  call: "mobile-call",
  whatsapp: "mobile-whatsapp",
  book: "mobile-book",
  map: "mobile-map",
};
